"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GraduationCapOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<ellipse cx="16" cy="12" rx="1.5" ry="1"/><path d="M29.6 11.56L17 7.14A3.26 3.26 0 0016 7a3.22 3.22 0 00-1 .14L2.42 11.56c-.54.19-.54.5 0 .69L15 16.67a2.94 2.94 0 001 .14 3 3 0 001-.14l5-1.76v5.54a.43.43 0 010 .11c-.23.36-1.72 2.44-6 2.44s-5.75-2.08-6-2.44v-3.48l-2-.7v4.12a2.63 2.63 0 00.22.95S10 25 16 25s7.78-3.55 7.78-3.55a2.63 2.63 0 00.22-.95v-6.29l2-.7v7.55a.94.94 0 00.94.94h.12a.94.94 0 00.94-.94v-8.25l1.6-.56c.53-.19.53-.5 0-.69zm-13.26 3.22a1.38 1.38 0 01-.33 0 1.2 1.2 0 01-.32 0l-8.2-2.87L15.68 9A1.38 1.38 0 0116 9a1.2 1.2 0 01.32 0l8.2 2.88z"/>';
var GraduationCapOutlineSVG = function GraduationCapOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.GraduationCapOutlineSVG = GraduationCapOutlineSVG;
GraduationCapOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(GraduationCapOutlineSVG);
exports.default = _default;